import React from "react";
import RadioOption, { RadioAttributes } from "./RadioOption";
import { Typography } from "@cappelendamm/design-system/react";

type Props = {
  options: (RadioAttributes & { key: string })[];
  title: string;
};

export default function RadioGroup({ options, title }: Props) {
  return (
    <fieldset className="flex flex-col gap-3">
      <h3>
        <Typography as="legend" variant="title-md">
          {title}
        </Typography>
      </h3>
      <div className="flex flex-col gap-2">
        {options.map((attributes) => (
          <RadioOption key={attributes.key} radioAttributes={attributes} />
        ))}
      </div>
    </fieldset>
  );
}
